// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/team-member.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / header-actions).

import type { ListPageConfig } from "../../components/composition/ListPage";
import { teamMembersApi } from "../../api/team-members";
import type { TeamMember } from "../../api/types";
// override-block:imports BEGIN
// CHG-1294 — per-page RBAC gate wiring consumed GATE_CATALOG/toGate here;
// CHG-2958 (Slice J) removed the imports together with the hidden no-op
// Invite header action (see header-actions block). Restore both imports
// when the openInviteFlow command ships.
// override-block:imports END

// override-block:helpers BEGIN
// override-block:helpers END

export const teamMemberListConfig: ListPageConfig<TeamMember> = {
  title: "Team members",
  subtitle: "Staff with dashboard access — manage roles, MFA, and session lifecycle.",
  queryKey: ["team-members", "list"] as const,
  queryFn: ({ page, pageSize, sortField, sortDirection, search }) =>
    teamMembersApi.listTeamMembers({ page, pageSize, sortField, sortDirection, search }),
  defaultSort: { field: "last_login_at", direction: "desc" },
  pageSize: 50,
  rowHref: "/team/{id}",
  search: { enabled: true, placeholder: "Search by name or email…" },
  emptyState: {
    title: "No team members yet",
    subtitle: "Invite teammates to give them dashboard access.",
  },
  headerActions: [
    // override-block:header-actions BEGIN
    // CHG-2958 (Slice J / UM-R12) — the forward-promised "Invite" button
    // is HIDDEN until the openInviteFlow command ships
    // (team-member.entity-hint.yaml#primary_actions[invite]). It used to
    // render as a visible primary button whose onClick was a no-op — the
    // exact dead-control clarity defect Slice J exists to remove. Staff
    // invites happen in the v1 dashboard (/users Add Member) today; v2
    // restores this action when the invite workflow lands. Re-enable by
    // restoring the action object with onClick: openInviteFlow and
    // permissionGate: toGate(GATE_CATALOG.team_list["invite"], "hide").
    // override-block:header-actions END
  ],
  columns: [
    { field: "full_name", label: "Name", type: "text", sortable: true },
    { field: "email", label: "Email", type: "email" },
    { field: "role", label: "Role", type: "text" },
    { field: "last_login_at", label: "Last active", type: "relative-date", sortable: true },
    { field: "status", label: "Status", type: "text" },
  ],
};
